import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../environments/environment';

import { LoginSendingData } from "../app/login/loginSendingData";
import { sendingRegistrationData } from "../app/register/sendingRegistrationData";
import moment from 'moment';
import { sanitizeIdentifier } from "@angular/compiler";
import { ɵDomAdapter } from "@angular/platform-browser";
import { ActivityMOccurrenceComponent } from "./activity-m-occurrence/activity-m-occurrence.component";
import { duration } from "moment";
import { ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
//import { lstat } from "fs";

@Injectable({
  providedIn: "root",
})
export class RestService {
  private url: string = "`${environment.apiURL}/bothome/";

  private content = new BehaviorSubject<any>("");
  public userDetails = this.content.asObservable();

  private regUser = new BehaviorSubject<any>("");
  private timeZoneValue = new BehaviorSubject<any>("");
  private singleDate = new BehaviorSubject<any>("");
  private filterData = new BehaviorSubject<any>(false);

  public regUserDetails = this.regUser.asObservable();
  public timezone = this.timeZoneValue.asObservable();
  public singleDateValue = this.singleDate.asObservable();
  public filterObj = this.filterData.asObservable();

  constructor(private http: HttpClient) {}

  loginCondition(loginData: LoginSendingData): Observable<any> {
    return this.http.post(
      `${environment.apiURL}/bothome/users/login`,
      loginData,
      {
        withCredentials: true
      }
    );
  }

  loggedIn() {
    return !!localStorage.getItem("token");
  }

  //Calling logout event
  callingLogout() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userId: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/users/logout`,
      httpOptions
    );
  }

  registrationCondition(
    registrationData: sendingRegistrationData
  ): Observable<any> {
    return this.http.post(
      `${environment.apiURL}/bothome/users/register`,
      registrationData
    );
  }

  // Sharing User Login data to other components
  getUserDetails(dt: any) {
    this.content.next(dt);
  }

  // Getting user list
  getUserLists() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/users/userList`,
      httpOptions
    );
  }

  //Get Okta users
  getOktaUser() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminId: localStorage.getItem("adminId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/users/getRoles`,
      httpOptions
    );
  }

  // Populating register users in Add user page
  updateRegisteredUserDetails(user: any) {
    return this.regUser.next(user);
  }

  selectedTimeZoneItem(user: any) {
    return this.timeZoneValue.next(user);
  }

  singleDateSelection(date: any) {
    return this.singleDate.next(date);
  }

  setFilterValues(val: any) {
    return this.filterData.next(val);
  }

  //Verifying email address
  verifyEmailAddress(tokenValue: string, time = false) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: tokenValue,
      }),
    };

    const url = time ? `${environment.apiURL}/bothome/users/validateToken2` : `${environment.apiURL}/bothome/users/validateToken`

    return this.http.get(
      url,
      httpOptions
    );
  }

  verifyingUserByToken(userid: any, admin: any, token: any, pwd: any) {
    const httpOptions = {
      headers: new HttpHeaders({
       "Content-Type": "application/json",
        userId: userid.toString(),
        isSuper: admin,
        accesstoken: token.toString(),
        secretKey: pwd,
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/users/createPassword`,
      httpOptions
    );
  }

  addingNewUserInList(
    firstname: any,
    lastname: any,
    emailid: any,
    selectedRole: any,
    roleset: any,
    roles: any
  ) {


    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
      }),
    };

    const body = JSON.stringify({
      FirstName: firstname,
      LastName: lastname,
      email: emailid,
      orgId: localStorage.getItem("OrgId"),
      adminId: localStorage.getItem("adminId"),
      roles: roleset,
      permissions: roles,
      loginType: localStorage.getItem("integrationType"),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/users/addUser`,
      body,
      httpOptions
    );
  }

  // While edit user details
  editUserDetails(uid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
         token: localStorage.getItem("token"),
        userid: localStorage.getItem("editUserId"),
        adminid: localStorage.getItem("adminId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/users/getUser`,
      httpOptions
    );
  }

  // Updating user detail from edit user page
  updatingUserDetails(
    eId: any,
    fName: any,
    lName: any,
    emailAdd: any,
    createdAt: any,
    roleId: any,
    editUserRole: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        userid: localStorage.getItem("editUserId"),
      }),
    };

    const body = JSON.stringify({
      user: {
        id: eId,
        FirstName: fName,
        LastName: lName,
        Email: emailAdd,
        CreatedAt: createdAt,
        RoleId: roleId,
      },
      roles: editUserRole,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/users/editUser`,
      body,
      httpOptions
    );
  }

  gettingCreditCardDetails(cnum: any, ed: any, cod: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgId: localStorage.getItem("OrgId"),
      }),
    };
    console.log("token----", httpOptions);
    

    const body = JSON.stringify({
      CardNumber: cnum,
      ExpirationDate: ed,
      Code: cod,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/users/acceptPayment`,
      body,
      httpOptions
    );
  }

  checkingTypeUsers(
    intergratetype: any,
    oktaToken: any,
    oktaUrl: any,
    dirUrl: any,
    dirBaseUrl: any,
    dirUsername: any,
    dirPwd: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgId: localStorage.getItem("OrgId"),
      }),
    };

    const body = JSON.stringify({
      intergrationType: intergratetype,
      OKTATOKEN: oktaToken,
      OKTAURL: oktaUrl,
      ADURL: dirUrl,
      ADbaseDN: dirBaseUrl,
      ADusername: dirUsername,
      ADpassword: dirPwd,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/users/adminSetup`,
      body,
      httpOptions
    );
  }

  updateUserStatus(statusid: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("editUserId"),
        adminid: localStorage.getItem("adminId"),
        status: statusid.toString(),
        orgid: localStorage.getItem("OrgId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/users/updateStatus`,
      httpOptions
    );
  }

  // Displaying user profiles in profile page
  getUserProfile() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/users/getProfile`,
      httpOptions
    );
  }

  //Get Subscription details
  gettingSubscription() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/subscription/getSubscription`,
      httpOptions
    );
  }

  //Deleting all subscription users
  deleteSubcription() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId"),
        subscriptionstatus: "2",
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/subscription/updateSubscription`,
      httpOptions
    );
  }

  //Suspending individual subscription users
  suspendingSubcription(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId"),
        subscriptionstatus: id.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/subscription/updateSubscription`,
      httpOptions
    );
  }

  //Manage payment method
  managePayment() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/subscription/managePayment`,
      httpOptions
    );
  }

  //Updating subscriber count when click + button in Edit Subscription model
  updatingSubscriptionCount(
    profee: any,
    totalsubscribe: any,
    fn: any,
    ln: any,
    em: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        proratefee: profee.toString(),
        totalsubscription: totalsubscribe.toString(),
        adminfirstname: fn.toString(),
        adminlastname: ln.toString(),
        adminemail: em.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/subscription/saveEditSubscription`,
      httpOptions
    );
  }

  //get Account Details
  getAccountDetails() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/account/getAccountDetails`,
      httpOptions
    );
  }

  //Edit Account Details
  editAccountDetails(
    companyName: any,
    streetAddress: any,
    country: any,
    state: any,
    city: any,
    zipCode: any,
    timezonename: any,
    em: any,
    fn: any,
    ln: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgId: localStorage.getItem("OrgId"),
      }),
    };

    const body = JSON.stringify({
      CompanyName: companyName,
      StreetAddress: streetAddress,
      Country: country,
      State: state,
      City: city,
      ZipCode: zipCode,
      TimeZone: timezonename,
      adminEmail: em,
      adminFirstName: fn,
      adminLastName: ln,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/account/editAccountDetails`,
      body,
      httpOptions
    );
  }

  //Getting Admin Transfer Details
  getAdminTransferDetails() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/account/getAdminTransferDetails`,
      httpOptions
    );
  }

  changePassword (oldPassword: string, newPassword: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        userid: localStorage.getItem("adminId"),
        token: localStorage.getItem("token")
      }),
    };

    const body = JSON.stringify({
      oldPassword: oldPassword,
      newPassword: newPassword
    });

    return this.http.post(
      `${environment.apiURL}/bothome/users/changePassword`,
      body,
      httpOptions
    );
  }

  resetPassword (userId: number, newPassword: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        userid: `${userId}`,
      }),
    };

    const body = JSON.stringify({
      newPassword: newPassword
    });

    return this.http.post(
      `${environment.apiURL}/bothome/users/resetPassword`,
      body,
      httpOptions
    );
  }

  forgotPassword (email: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
    };

    const body = JSON.stringify({
      email: email
    });

    return this.http.post(
      `${environment.apiURL}/bothome/users/forgotPassword`,
      body,
      httpOptions
    );
  }

  // User to admin transfer
  superAdminTransfer(
    userid: any,
    phone: any,
    altPhone: any,
    convertRole: any,
    roleId: any,
    password: any,
    email: any,
    firstName: any,
    lastName: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgId: localStorage.getItem("OrgId"),
      }),
    };

    const body = JSON.stringify({
      userid: userid,
      phone: phone,
      altPhone: altPhone,
      convertRole: convertRole,
      roleId: roleId,
      password: password,
      email: email,
      firstName: firstName,
      lastName: lastName,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/account/superAdminTransfer`,
      body,
      httpOptions
    );
  }

  //Verifying Admin Transfer
  verifyAdminTransfer(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        accesstoken: token,
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/account/verifyAdminTransfer`,
      httpOptions
    );
  }

  getIntegrationDetail() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgId: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/integration/getIntegrationDetail`,
      httpOptions
    );
  }

  updateIntegrationDetail(
    IntegrationTypeId: any,
    OKTAOrgURL: any,
    OKTAToken: any,
    ADURL: any,
    ADBaseDN: any,
    ADUserName: any,
    ADPassWord: any,
    em: any,
    fn: any,
    ln: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgId: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId"),
      }),
    };

    const body = JSON.stringify({
      IntegrationType: IntegrationTypeId,
      OKTA_Org_URL: OKTAOrgURL,
      OKTA_Token: OKTAToken,
      AD_URL: ADURL,
      AD_BaseDN: ADBaseDN,
      AD_UserName: ADUserName,
      AD_PassWord: ADPassWord,
      adminEmail: em,
      adminFirstName: fn,
      adminLastName: ln,
      orgName: localStorage.getItem("orgname"),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/integration/updateIntegrationDetail`,
      body,
      httpOptions
    );
  }

  testIntegrationConnection(
    IntegrationTypeId: any,
    OKTAOrgURL: any,
    OKTAToken: any,
    ADURL: any,
    ADBaseDN: any,
    ADUserName: any,
    ADPassWord: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgId: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId"),
      }),
    };

    const body = JSON.stringify({
      IntegrationType: IntegrationTypeId,
      OKTA_Org_URL: OKTAOrgURL,
      OKTA_Token: OKTAToken,
      AD_URL: ADURL,
      AD_BaseDN: ADBaseDN,
      AD_UserName: ADUserName,
      AD_PassWord: ADPassWord,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/integration/testIntegrationConnection`,
      body,
      httpOptions
    );
  }

  testAAConnection(
    addEnvironmentName: any,
    addEnvironmentControlRoom: any,
    addEnvironmentUsername: any,
    addEnvironmentAPIKey: any,
    addEnvironmentPassword: any,
    AAType: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId"),
      }),
    };

    const body = JSON.stringify({
      EnvironmentName: addEnvironmentName,
      AA_ControlRoomURL: addEnvironmentControlRoom,
      AA_UserName: addEnvironmentUsername,
      AA_API_Key: addEnvironmentAPIKey,
      AA_PassWord: addEnvironmentPassword,
      AA_Type: AAType,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/integration/testAAConnection`,
      body,
      httpOptions
    );
  }

  updateAADetail(crurl: any, crusername: any, crpwd: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgId: localStorage.getItem("OrgId"),
      }),
    };

    const body = JSON.stringify({
      AA_ControlRoomURL: crurl,
      AA_UserName: crusername,
      AA_PassWord: crpwd,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/integration/updateAADetail`,
      body,
      httpOptions
    );
  }

  aaLogin() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
      withCredentials: true 
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/systemAccess/refreshBotMachineList`,
      httpOptions
    );
  }

  getMachineLists() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/machine/getMachineLists`,
      httpOptions
    );
  }

  environmentList() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        token: localStorage.getItem("token"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/integration/environmentList`,
      httpOptions
    );
  }

  environmentMasterList() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        token: localStorage.getItem("token"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/integration/environmentMasterList`,
      httpOptions
    );
  }

  updateEnvironment(
    eid: any,
    ename: any,
    eroomurl: any,
    eusername: any,
    eapikey: any,
    epwd: any,
    eaatype: any,
    masterenvid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgId: localStorage.getItem("OrgId"),
        masterenvid: masterenvid,
        envid: eid.toString(),
      }),
    };

    const body = JSON.stringify({
      EnvironmentName: ename,
      AA_ControlRoomURL: eroomurl,
      AA_UserName: eusername,
      AA_PassWord: epwd,
      AA_API_Key: eapikey,
      AA_Type: eaatype.toString(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/integration/updateEnvironment`,
      body,
      httpOptions
    );
  }

  removeEnvironment(eid: any, meid: any, type: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId"),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
        type: type
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/integration/removeEnvironment`,
      httpOptions
    );
  }

  addEnvironment(
    addEnvironmentName: any,
    addEnvironmentControlRoom: any,
    addEnvironmentUsername: any,
    addEnvironmentAPIKey: any,
    addEnvironmentPassword: any,
    AAType: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgId: localStorage.getItem("OrgId"),
      }),
    };

    const body = JSON.stringify({
      EnvironmentName: addEnvironmentName,
      AA_ControlRoomURL: addEnvironmentControlRoom,
      AA_UserName: addEnvironmentUsername,
      AA_PassWord: addEnvironmentPassword,
      AA_API_Key: addEnvironmentAPIKey,
      AA_Type: AAType,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/integration/addEnvironment`,
      body,
      httpOptions
    );
  }

  addsystemAccess(levelname: any, description: any, envList: any, path: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgId: localStorage.getItem("OrgId"),
      }),
    };

    const body = JSON.stringify({
      categoryName: levelname,
      categoryDesc: description,
      levelNumber: 1,
      parentID: 0,
      envId: 1,
      path: path,
      EnvList: envList,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Infrastructure/systemAccess/addsystemAccess`,
      body,
      httpOptions
    );
  }

  getsystemAccess(id: any, etype: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envId: id.toString(),
        ismastertemplate: etype.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/systemAccess/getsystemAccess`,
      httpOptions
    );
  }

  getMachineDetail(id: any, mid: any, meid: any, envType: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        machineorgidparentenv: id.toString(),
        machineid: mid.toString(),
        masterenvid: meid && meid.toString(),
        envtype: envType
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/machine/getMachineDetail`,
      httpOptions
    );
  }

  updateMachineDetail(
    mid: any,
    configId: any,
    systemList: any,
    machineorgidparentenv: any,
    eid: any,
    conf: any,
    acc: any,
    meid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        machineid: mid.toString(),
        machineorgidparentenv: machineorgidparentenv.toString(),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      configured: configId.toString(),
      systemAccess: systemList,
      ifConfigEdit: parseInt(conf),
      ifAccessEdit: parseInt(acc),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Infrastructure/machine/updateMachineDetail`,
      body,
      httpOptions
    );
  }

  getBotLists() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/bot/getBotLists`,
      httpOptions
    );
  }

  getBotDetail(id: any, bid: any, meid: any, envType) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        botparentenv: id.toString(),
        botid: bid.toString(),
        masterenvid: meid && meid.toString(),
        envtype: envType
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/bot/getBotDetail`,
      httpOptions
    );
  }

  updateBotDetail(
    bid: any,
    alias: any,
    configured: any,
    systemList: any,
    BotorgIdParentENV: any,
    eid: any,
    congEdit: any,
    aliasEdit: any,
    accessEdit: any,
    meid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        botid: bid.toString(),
        botparentenv: BotorgIdParentENV.toString(),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      GeneralNotification: localStorage.getItem("general"),
      IndividualNotification: localStorage.getItem("individual"),
      alias: alias,
      configured: configured.toString(),
      systemAccess: systemList,
      ifConfigEdit: parseInt(congEdit),
      ifAliasEdit: parseInt(aliasEdit),
      ifAccessEdit: parseInt(accessEdit),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Infrastructure/bot/updateBotDetail`,
      body,
      httpOptions
    );
  }

  deleteBot(bid: any, eid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        botid: bid.toString(),
        envid: eid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/bot/deleteBot`,
      httpOptions
    );
  }

  refreshBotList(meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/bot/refreshBotList`,
      httpOptions
    );
  }

  refreshMachineList(meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/machine/refreshMachineList`,
      httpOptions
    );
  }

  getsystemAccessMasterTemplate(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envId: id.toString(),
        ismastertemplate: "1",
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/systemAccess/getsystemAccess`,
      httpOptions
    );
  }

  addsystemAccessLevel(
    lid: any,
    cid: any,
    addlevelName: any,
    adddescription: any,
    environmentList: any,
    path: any
  ) {
    let level: any = lid + 1;

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgId: localStorage.getItem("OrgId"),
      }),
    };

    const body = JSON.stringify({
      categoryName: addlevelName.toString(),
      categoryDesc: adddescription.toString(),
      levelNumber: level.toString(),
      parentID: cid.toString(),
      envId: 1,
      path: path,
      EnvList: environmentList,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Infrastructure/systemAccess/addsystemAccess`,
      body,
      httpOptions
    );
  }

  deleteSystemAccess(cid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        categoryid: cid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/systemAccess/deleteSystemAccess`,
      httpOptions
    );
  }

  editsystemAccess(
    cid: any,
    cname: any,
    cdesc: any,
    levelnumber: any,
    parentid: any,
    path: any,
    environmentList: any,
    catname: any,
    catdes: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgId: localStorage.getItem("OrgId"),
      }),
    };

    const body = JSON.stringify({
      categoryId: cid.toString(),
      categoryName: cname.toString(),
      categoryDesc: cdesc.toString(),
      levelNumber: levelnumber.toString(),
      parentID: parentid.toString(),
      path: path,
      envId: 1,
      EnvList: environmentList,
      isCatNameEdited: catname,
      isCatDescEdit: catdes,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Infrastructure/systemAccess/editsystemAccess`,
      body,
      httpOptions
    );
  }

  getParentList(cid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        categoryid: cid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/systemAccess/getParentList`,
      httpOptions
    );
  }

  environmentDetail(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envid: id.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/integration/environmentDetail`,
      httpOptions
    );
  }

  filterBotLists(eid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envid: eid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/bot/filterBotLists`,
      httpOptions
    );
  }

  filterMachineList(eid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envid: eid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Infrastructure/machine/filterMachineList`,
      httpOptions
    );
  }

  getBotsActivity(eid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/bot/getBotsActivity`,
      httpOptions
    );
  }

  getBotOccurance(eid: any, bid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        botid: bid.toString(),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/bot/getBotOccurance`,
      httpOptions
    );
  }

  getBotSeries(eid: any, bid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        botid: bid.toString(),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/bot/getBotSeries`,
      httpOptions
    );
  }

  getBotSeriesOccurance(sid: any, botid: any, eid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        botid: botid.toString(),
        seriesid: sid.toString(),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/bot/getBotSeriesOccurance`,
      httpOptions
    );
  }

  getMaintenceList(eid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/maintenace/getMaintenceList`,
      httpOptions
    );
  }

  getMaintenceOccurance(eid: any, sid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envid: eid.toString(),
        systemid: sid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/maintenace/getMaintenceOccurance`,
      httpOptions
    );
  }

  getMaintenceSeriesOccurance(eid: any, sid: any, ssid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envid: eid.toString(),
        systemid: sid.toString(),
        seriesid: ssid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/maintenace/getMaintenceSeriesOccurance`,
      httpOptions
    );
  }

  getMaintenceSeries(eid: any, sid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        userid: localStorage.getItem("adminId"),
        envid: eid.toString(),
        systemid: sid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/maintenace/getMaintenceSeries`,
      httpOptions
    );
  }

  getEnvBotList(eid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        token: localStorage.getItem("token"),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/getEnvBotList`,
      httpOptions
    );
  }

  getEnvMachineList(eid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/getEnvMachineList`,
      httpOptions
    );
  }

  createJobSchedule(
    eid: any,
    bid: any,
    sdes: any,
    stype: any,
    sdate: any,
    mid: any,
    h: any,
    m: any,
    sm: any,
    ed: any,
    occid: any,
    meid: any
  ) {

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      envId: parseInt(eid),
      botId: parseInt(bid),
      scheduleDesc: sdes,
      startType: parseInt(stype),
      startDate: sdate,
      machineId: parseInt(mid),
      jobDuration: {
        hours: h.toString(),
        minutes: m.toString(),
      },
      smartmatch: sm,
      isPreview: true,
      isEdit: ed,
      occuranceId: parseInt(occid),
      timezoneOffSet: moment((sdate[0] || new Date())).utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/createJobSchedule`,
      body,
      httpOptions
    );
  }

  saveJobSchedule(
    eid: any,
    des: any,
    stype: any,
    h: any,
    m: any,
    occurance: any,
    meid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      GeneralNotification: localStorage.getItem("general"),
      IndividualNotification: localStorage.getItem("individual"),
      envid: parseInt(eid),
      description: des.toString(),
      startType: parseInt(stype),
      jobDuration: {
        hours: h.toString(),
        minutes: m.toString(),
      },
      occuranceList: occurance,
      timezoneOffSet: moment( (occurance[0] && occurance[0].startDate) || new Date()).utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/saveJobSchedule`,
      body,
      httpOptions
    );
  }

  createJobRecurringSchedule(
    eid: any,
    bid: any,
    sname: any,
    sdes: any,
    rtype: any,
    ropt: any,
    range: any,
    tpattern: any,
    h: any,
    m: any,
    mid: any,
    sm: any,
    meid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      envId: parseInt(eid),
      botId: parseInt(bid),
      seriesName: sname,
      seriesDescription: sdes,
      repeatType: parseInt(rtype),
      repeatOption: ropt,
      range: range,
      timePattern: tpattern,
      jobDuration: {
        hours: h.toString(),
        minutes: m.toString(),
      },
      machineId: parseInt(mid),
      smartmatch: sm,
      timezoneOffSet: moment(range.startdate).utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/createJobRecurringSchedule`,
      body,
      httpOptions
    );
  }

  saveRecJobSchedule(
    eid: any,
    bid: any,
    sname: any,
    sdes: any,
    rtype: any,
    h: any,
    m: any,
    frequency: any,
    mid: any,
    sdate: any,
    edate: any,
    occ: any,
    meid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      GeneralNotification: localStorage.getItem("general"),
      IndividualNotification: localStorage.getItem("individual"),
      envid: parseInt(eid),
      botid: parseInt(bid),
      seriesName: sname.toString(),
      description: sdes.toString(),
      repeatType: parseInt(rtype),
      jobDuration: {
        hours: h.toString(),
        minutes: m.toString(),
      },
      frequency: frequency.toString(),
      machineId: parseInt(mid),
      startDate: sdate.toString(),
      endDate: edate.toString(),
      occuranceList: occ,
      timezoneOffSet: moment( (occ[0] && occ[0].startDate) || new Date()).utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/saveRecJobSchedule`,
      body,
      httpOptions
    );
  }

  createMaintenanceSchedule(
    lab: any,
    eid: any,
    sa: any,
    des: any,
    sdates: any,
    r: any,
    ed: any,
    occid: any,
    meid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      activityLabel: lab,
      envId: parseInt(eid),
      systemAccess: sa,
      description: des,
      selectDates: sdates,
      range: r,
      isEdit: ed,
      moccuranceId: parseInt(occid),
      timezoneOffSet: moment( sdates[0] || new Date()).utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/createMaintenanceSchedule`,
      body,
      httpOptions
    );
  }

  saveMaintenance(
    eid: any,
    lab: any,
    des: any,
    duration: any,
    sa: any,
    oc: any,
    meid: any,
    allenv: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      envid: parseInt(eid),
      activityLabel: lab.toString(),
      description: des.toString(),
      jobDuration: duration,
      systemAccess: sa,
      occuranceList: oc,
      allenv: false,
      timezoneOffSet: moment( (oc[0] && oc[0].NewStart) || new Date() ).utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/saveMaintenance`,
      body,
      httpOptions
    );
  }

  createRecurringMaintenanceSchedule(
    lab: any,
    eid: any,
    sn: any,
    sa: any,
    des: any,
    rtype: any,
    roption: any,
    r: any,
    st: any,
    et: any,
    meid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };
    const body = JSON.stringify({
      activityLabel: lab.toString(),
      envId: parseInt(eid),
      seriesName: sn.toString(),
      systemAccess: sa,
      description: des.toString(),
      repeatType: parseInt(rtype),
      repeatOption: roption,
      range: r,
      startOption: st,
      endOption: et,
      timezoneOffSet: moment(r.startdate).utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/createRecurringMaintenanceSchedule`,
      body,
      httpOptions
    );
  }

  bulkConfigUpdate(setConfig: boolean, selectedMachines: any [], selectMachine: any, 
    systemAccess: any, machines: any []) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId")
      }),
    };

    const body = JSON.stringify({
      configured: 1,
      ifAccessEdit: 1,
      ifConfigEdit: setConfig ? 1 : 0,
      systemAccess: systemAccess,
      machines: machines.map(m => m.MachineId),
      envid: selectMachine.Environment,
      masterenvid: selectMachine.MasterEnvId
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Infrastructure/machine/bulkUpdateMachineDetail`,
      body,
      httpOptions
    );
  }

  saveRecMaintenance(
    eid: any,
    lab: any,
    des: any,
    sname: any,
    rtype: any,
    sd: any,
    ed: any,
    sa: any,
    duration: any,
    occ: any,
    meid: any,
    allenv: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      envid: parseInt(eid),
      activityLabel: lab.toString(),
      description: des.toString(),
      seriesName: sname.toString(),
      repeatType: parseInt(rtype),
      startDate: sd.toString(),
      endDate: ed.toString(),
      systemAccess: sa,
      jobDuration: duration,
      occuranceList: occ,
      allenv: false,
      timezoneOffSet: moment( (occ[0] && occ[0].NewStart) || new Date()).utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/saveRecMaintenance`,
      body,
      httpOptions
    );
  }

  getCalenderView(eid: any, fd: any, td: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        fromdate: fd.toString(),
        todate: td.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      isFilter: JSON.parse(localStorage.getItem("isFilter")),
      machineIds: JSON.parse(localStorage.getItem("mids")),
      botIds: JSON.parse(localStorage.getItem("bids")),
      systemIds: JSON.parse(localStorage.getItem("sids")),
      timezoneOffSet: moment().utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/DataView/getCalenderView`,
      body,
      httpOptions
    );
  }

  getTimeLineView(eid: any, fd: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid,
        fromdate: fd.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      isFilter: JSON.parse(localStorage.getItem("isFilter")),
      machineIds: JSON.parse(localStorage.getItem("mids")),
      botIds: JSON.parse(localStorage.getItem("bids")),
      systemIds: JSON.parse(localStorage.getItem("sids")),
      timezoneOffSet: moment().utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/DataView/getTimeLineView`,
      body,
      httpOptions
    );
  }

  getTableView(eid: any, fd: any, td: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        fromdate: fd.toString(),
        todate: td.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      isFilter: JSON.parse(localStorage.getItem("isFilter")),
      machineIds: JSON.parse(localStorage.getItem("mids")),
      botIds: JSON.parse(localStorage.getItem("bids")),
      systemIds: JSON.parse(localStorage.getItem("sids")),
      timezoneOffSet: moment().utcOffset(),
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/DataView/getTableView`,
      body,
      httpOptions
    );
  }

  delOccurance(eid: any, occid: any, bid: any, mid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        occuranceid: occid.toString(),
        botid: bid.toString(),
        machineid: mid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/delOccurance`,
      httpOptions
    );
  }

  delSeries(eid: any, sid: any, bid: any, mid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        seriesid: sid.toString(),
        botid: bid.toString(),
        machineid: mid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/delSeries`,
      httpOptions
    );
  }

  delAllOccurance(eid: any, bid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        botid: bid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/bot/delAllOccurance`,
      httpOptions
    );
  }

  delMaintenanceOccurance(eid: any, sid: any, mid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        systemid: sid.toString(),
        moccuranceid: mid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/delMaintenanceOccurance`,
      httpOptions
    );
  }

  delMaintenanceSeries(eid: any, sysid: any, sid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        systemid: sysid.toString(),
        seriesid: sid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/delMaintenanceSeries`,
      httpOptions
    );
  }

  delAllMOccurance(eid: any, sysid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        systemid: sysid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/ActivityCatalog/maintenace/delAllMOccurance`,
      httpOptions
    );
  }

  getJobOccuranceDetail(eid: any, occid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        jobOccuranceid: occid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/getJobOccuranceDetail`,
      httpOptions
    );
  }

  editOccurance(
    occid: any,
    eid: any,
    des: any,
    sdate: any,
    edate: any,
    bid: any,
    mid: any,
    st: any,
    fl: any,
    duration: any,
    fm: any,
    meid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      occuranceId: parseInt(occid),
      envId: parseInt(eid),
      scheduleDesc: des.toString(),
      startType: 3,
      startDate: new Date(sdate).toISOString(),
      endDate:  new Date(edate).toISOString(),
      botId: bid,
      machineId: mid,
      Status: st,
      flagged: fl,
      jobDuration: duration,
      flaggedMid: fm,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/editOccurance`,
      body,
      httpOptions
    );
  }

  getMaintenanceOccurance(eid: any, mid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        moccuranceid: mid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/getMaintenanceOccurance`,
      httpOptions
    );
  }

  editMOccurance(
    mid: any,
    eid: any,
    lab: any,
    des: any,
    sdate: any,
    edate: any,
    d: any,
    st: any,
    meid: any
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      mOccuranceId: parseInt(mid),
      envId: parseInt(eid),
      activityLabel: lab.toString(),
      description: des.toString(),
      startDate: new Date(sdate).toISOString(),
      endDate: new Date(edate).toISOString(),
      duration: d,
      status: st,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/editMOccurance`,
      body,
      httpOptions
    );
  }

  getSeriesDetail(eid: any, sid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        seriesid: sid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/getSeriesDetail`,
      httpOptions
    );
  }

  editSeriesOccurance(eid: any, hd: any, eo: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      headers: hd,
      editOccurance: eo,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/JobScheduler/editSeriesOccurance`,
      body,
      httpOptions
    );
  }

  getMaintenanceSeries(eid: any, sid: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        seriesid: sid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/getMaintenanceSeries`,
      httpOptions
    );
  }

  editRecMaintenance(eid: any, sid: any, hd: any, oc: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        seriesid: sid.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };

    const body = JSON.stringify({
      headerObj: hd,
      OccuranceTable: oc,
    });

    return this.http.post(
      `${environment.apiURL}/bothome/Scheduler/Maintenance/editRecMaintenance`,
      body,
      httpOptions
    );
  }

  getMachineLogs() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/AuditLogs/getMachineLogs`,
      httpOptions
    );
  }

  getBotLogs() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/AuditLogs/getBotLogs`,
      httpOptions
    );
  }

  getSystemLogs() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/AuditLogs/getSystemLogs`,
      httpOptions
    );
  }

  getUserLogs() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/AuditLogs/getUserLogs`,
      httpOptions
    );
  }

  getLeftPanelData(eid: any, ftype: any, ls: any, asm: any, meid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        envid: eid.toString(),
        fromdate: "2020-05-22",
        filtertype: ftype.toString(),
        limitselection: ls.toString(),
        autoselectmaintenance: asm.toString(),
        masterenvid: meid && meid.toString(),
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/Scheduler/DataView/getLeftPanelData`,
      httpOptions
    );
  }

  getUserNotification() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/Notifications/getUserNotification`,
      httpOptions
    );
  }

  updateNotification(gnt: any, ind: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        userid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
        general: gnt.toString(),
        individual: ind.toString(),
      }),
    };

    return this.http.get(
      `${environment.apiURL}/bothome/users/upNotification`,
      httpOptions
    );
  }

  // Stripe. To do move to separate Controller

  setupPaymentIntent(
    email: string
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        adminid: localStorage.getItem("adminId"),
        orgid: localStorage.getItem("OrgId"),
      }),
    };

    const body = JSON.stringify({
      email: email
    });

    return this.http.post(
      `${environment.apiURL}/bothome/subscription/stripe/setupIntent`,
      body,
      httpOptions
    );
  }

  verifyPayment(
    intentToken: string
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId")
      }),
    };

    const body = JSON.stringify({
      intentId: intentToken
    });

    return this.http.post(
      `${environment.apiURL}/bothome/subscription/stripe/verifyIntent`,
      body,
      httpOptions
    );
  }

  retrievePayment() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId")
      }),
    };
    return this.http.get(
      `${environment.apiURL}/bothome/subscription/stripe/retrievePayment`,
      httpOptions
    );
  }

  // UI Path
  testUIPathConnection(accountId: string, accountSecret: string){
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId")
      }),
    };
    
    const body = {
      applicationId: accountId,
      applicationSecret: accountSecret,
    };

    return this.http.post(
      `${environment.apiURL}/bothome/uipath/test`,
      body,
      httpOptions
    );
  }

  addUIPathEnvironment(
    envName: string,
    envType: string,
    orgName: string,
    tenantName: string,
    controlRoomUrl: string,
    accountId: string, 
    accountSecret: string
  ){
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId"),
      }),
    };
    
    const body = {
      applicationId: accountId,
      applicationSecret: accountSecret,
      envName: envName,
      envType: envType,
      orgName: orgName,
      tenantName: tenantName,
      controlRoomUrl: controlRoomUrl,
    };

    return this.http.post(
      `${environment.apiURL}/bothome/uipath/addEnvironment`,
      body,
      httpOptions
    );
  }

  editUIPathEnvironment(
    envId: string,
    masterEnvironmentId: string,
    envName: string,
    envType: string,
    orgName: string,
    tenantName: string,
    controlRoomUrl: string,
    accountId: string, 
    accountSecret: string
  ){
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: localStorage.getItem("token"),
        orgid: localStorage.getItem("OrgId"),
        adminid: localStorage.getItem("adminId")
      }),
    };
    
    const body = {
      applicationId: accountId,
      applicationSecret: accountSecret,
      envName: envName,
      envType: envType,
      orgName: orgName,
      tenantName: tenantName,
      controlRoomUrl: controlRoomUrl,
      envId: envId,
      meId: masterEnvironmentId
    };

    return this.http.post(
      `${environment.apiURL}/bothome/uipath/editEnvironment`,
      body,
      httpOptions
    );
  }
}
